import { ZodNumber } from 'zod';

import { MAX_32_BIT_INTEGER_ERROR_MESSAGE_TEXT } from '@occc-app/lib/constants/validationMessages';

export const MAX_32_BIT_INT = 2147483647;

// Any number larger than this will cause an BAD_USER_INPUT API error.
// So we have to validate the input from the FE side as well.

export const Max32bitIntSchema = (schema: ZodNumber) =>
  schema.max(MAX_32_BIT_INT, MAX_32_BIT_INTEGER_ERROR_MESSAGE_TEXT);
